// extracted by mini-css-extract-plugin
module.exports = {"text":"Content_text__TFAlU","list":"Content_list__Gp8fF","actions":"Content_actions__7cuaR","action":"Content_action__ybRLW"};